<template>
  <div class="checkout">
    <div class="historys" v-if="histroyComments.length>0">
      <h5>历史报修：</h5>
      <ul class="items">
        <li v-for="(item, index) in histroyComments" :key="index">
          <p>{{ index + 1 }}、{{ item.userComment }}</p>
          <div class="imgList">
            <div
              v-for="(iitem, inx) in item.photoList"
              :key="inx"
              class="photos"
            >
              <img :src="iitem" alt="" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="checkoutContent">
      <van-field
        v-model="messages"
        rows="2"
        autosize
        label="描述"
        type="textarea"
        maxlength="100"
        placeholder="请输入留言"
        show-word-limit
      />
      <div style="margin-top: 40px">
        <span style="margin-right: 10px; font-size: 14px">上传图片</span>
        <van-uploader
          :after-read="afterRead"
          :max-count="4"
          v-model="fileList"
          class="uploader"
        >
          <!-- <span>点击调用摄像头进行拍摄</span> -->
        </van-uploader>
      </div>
      <div style="text-align: center; margin-top: 30px">
        <van-button round type="info" size="normal" @click="submitComment"
          >提交报修</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  cancelRoom,
  upLoadPicture,
  submitRepaires,
  queryRepaire,
} from "../../apis/api.js";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      messages: "",
      fileList: [],
      uploadList: [],
      histroyComments: [],
    };
  },
  mounted() {
    document.title = "提交报修";
    console.log(this.$route.query);
    queryRepaire({
      appointmentId: Number(this.$route.query.id),
      pageNo: 1,
      pageSize: 10,
    }).then((res) => {
      console.log(res, "comment");
      this.histroyComments = res.result.records;
    });
  },
  methods: {
    afterRead(file) {
      console.log(file);
      file.status = "uploading";
      file.message = "上传中...";

      upLoadPicture({
        img: file.content,
        openId: localStorage.getItem("openId"),
        ext: file.file.name.split(".")[1],
      }).then((res) => {
        console.log(res);
        this.uploadList.push(res.result.savePath);
        Toast("上传成功");
        this.personImg = res.result.savePath;
        file.status = "done";
        file.message = "上传成功";
      });
    },
    submitComment() {
      submitRepaires({
        appointmentId: this.$route.query.id,
        photoList: this.uploadList,
        userComment: this.messages,
      }).then((res) => {
        this.$toast("提交成功");
        this.$router.go(-1);
        // roomCheckout({
        // 	id: this.$route.query.id,
        // 	openId: localStorage.getItem("openId"),
        // 	roomId: this.$route.query.roomId
        // }).then(xhr => {
        // 	Dialog({
        // 		message: "退房成功"
        // 	});
        // 	setTimeout(()=>{
        // 		this.$router.go(-1)
        // 	},200)
        // 	//
        // 	// this.pageNo = 1;
        // 	// this.getHistoryLists()
        // })
      });
    },
  },
};
</script>

<style lang="less" scoepd>
.checkout {
  padding: 20px;
}

.historys {
  h5 {
    font-size: 30px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }
  .items {
    li {
      p {
        font-size: 20px;
        margin-bottom: 10px;
      }
      img {
        width: 160px;
        height: 160px;
        margin-right: 20px;
        border: 1px solid #eee;
        border-radius: 3px;
      }
    }
  }
}
.imgList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
